import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
import { IdEventSoundCore } from "../../../utils/sound/IdEventSoundCore";
import { utilButton } from "../../../utils/utilButton";
export var ShopPageIndicator = function (_a) {
    var selected = _a.selected, onClick = _a.onClick, pageIdx = _a.pageIdx;
    var className = selected ? IdStyles.OfferPageIndicatorSelected : IdStyles.OfferPageIndicator;
    var clickLauncher = onClick ? function () { return onClick(pageIdx); } : undefined;
    return (React.createElement("div", { className: className, onClick: function () {
            return utilButton.onClickWithSound(clickLauncher, IdEventSoundCore.ButtonPagerClick);
        } }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/shop/components/ShopPageIndicator.tsx
// module id = 2907
// module chunks = 3